export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const CURRENT_DATE_OVERRIDE_FOR_MODEL_LINE_PREDICTION = '20/8/2019';
export const GRAPH_QL_ENDPOINT = '/api';
